module.exports = __webpack_public_path__ + "static/media/roboto_medium.c18ee39f.woff2";